/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Lower_Frog_EditInputs */

const fr_game_lower_frog_edit = /** @type {(inputs: Game_Lower_Frog_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance (m)`)
};

/**

* @param {Game_Lower_Frog_EditInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const game_lower_frog_edit = /** @type {((inputs?: Game_Lower_Frog_EditInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Lower_Frog_EditInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_game_lower_frog_edit(inputs)
});